<template>
  <client-only>
    <div class="staking-pool-page bg--color-02 pb-48 pb-148--l pt-24 pt-48--l">
      <div class="staking-pool-page__container container-new">
        <div class="staking-pool-page__head mb-24 mb-48--l">
          <div
            class="staking-pool-page__head-coll staking-pool-page__head-coll--info"
          >
            <h3
              class="txt--26px txt--52px--l txt--height-34px txt--height-64px--l txt--bold mb-10 mb-12--l"
              v-text="$t('staking.title')"
            />
            <p
              class="txt--14px txt--22px txt--height-18px txt--height-30px txt--color-03 mb-0"
              v-text="$t('staking.stakingPoolDescription')"
            />
          </div>
          <div class="staking-pool-page__head-coll">
            <exc-button
              class="staking-pool-page__button"
              :to="localePath('/c-freezer/history')"
              color="dark"
              outline
              size="s"
            >
              {{ $t('staking.historyStaking.title') }}
            </exc-button>
          </div>
        </div>
        <div class="staking-pool-page__list">
          <investment-cards-block />
        </div>
      </div>
    </div>
  </client-only>
</template>

<script>
import { ExcButton } from '@/components/common'
import { mapState } from 'vuex'
import { getDefaultHeadData } from '@/lib/utils'

export default {
  name: 'StakingPool',
  components: {
    InvestmentCardsBlock: () =>
      import(
        /* webpackMode: "eager" */ '@/components/staking-pool/InvestmentCardsBlock.vue'
      ),
    ExcButton,
  },
  head () {
    return getDefaultHeadData({
      title: this.$t('meta.cFreezer.title'),
      description: this.$t('meta.cFreezer.description'),
      img: '/image/meta/og-c-freezer.png',
      locale: this.$i18n.locale,
    })
  },
  computed: {
    ...mapState({
      isLogined: state => state.auth.loggedIn,
    }),
  },
}
</script>

<style lang="scss" scoped>
.staking-pool-page {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;

  &__container {
    position: relative;
    z-index: 1;
  }

  &__head {
    display: flex;
    flex-direction: column;
    gap: toRem(28px);

    @include bp(l) {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: toRem(20px);
    }
  }

  &__head-coll {
    &--info {
      width: 100%;

      @include bp(l) {
        width: 60%;
      }
    }
  }

  &__list {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
}
</style>
